export const carousselSlidesSizes = {
  horizontal: {
    width: {
      default: 340,
      1366: 238,
      500: 182,
    },
    height: {
      default: 187.31,
      1366: 131.64,
      500: 102.39,
    },
  },
  vertical: {
    width: {
      default: 340,
      1366: 238,
      500: 182,
    },
    height: {
      default: 477,
      1366: 293.91,
      500: 221.54,
    },
  },
};
